import React from 'react';
import useFetch from '../../../../components/hooks/useFetch.js';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog.js';
import {
  CENTRO_CUSTO_EXCLUIR
} from '../../../../services/permissoesRecebidas.js';

function FormExcluirCentroCusto({
  acaoCancelar,
  acaoFechar,
  centroCustoSelecionado,
  contratoSelecionado,
  idCorreios,
  idCorreiosPJ,
}) {
  const { request } = useFetch();
  const cancelar = (ev) => {
    ev.preventDefault();
    acaoCancelar();
  };

  const excluir = async () => {
    const { response } = await request(
      CENTRO_CUSTO_EXCLUIR(idCorreios, 
        idCorreiosPJ, 
        contratoSelecionado.nuContrato, 
        contratoSelecionado.contrato.nuSe, 
        centroCustoSelecionado.nuCentroCusto),
    );

    if (response.ok) {
      abreAlertaDialog('Centro de Custo excluido com sucesso!');
      acaoFechar();
    }
  };

  return (
    <>
      <div className="dialog-container">
        <div className="dialog-header">
          <h2>Excluir "{centroCustoSelecionado?.nuCentroCusto}"</h2>
        </div>
        <div className="dialog-main" id="dialog-main-email">
          Tem certeza de que deseja excluir esse Centro de Custo?
        </div>
        <div className="dialog-footer">
          <button className="btn-txt btn-fecha-dialog" onClick={cancelar}>
            Cancelar
          </button>
          <button className="btn-pre" id="btn-excluir" onClick={excluir}>
            Excluir
          </button>
        </div>
      </div>
    </>
  );
}
export default FormExcluirCentroCusto;
